<div class="page-wrapper" *ngIf="isActivePeriod; else inactivePeriod">
  <h1>M30 letöltés</h1>
  
  <app-m30-grid [forAdmin]="false"></app-m30-grid>
</div>

<ng-template #inactivePeriod>
  <div class="inactive-period-message">
    <h2>Az M30 letöltés csak február 1. és július 31. között érhető el.</h2>
  </div>
</ng-template>